// eslint-disable-next-line no-barrel-files/no-barrel-files
export type {
  GetValueOptions,
  SupportedFlagTypes,
  FeatureFlagClientInterface,
} from '@atlassiansox/feature-flag-web-client';

// TODO: Remove this duplicate
export type TownsquareApp = 'home' | 'goals' | 'teams';

// TODO: Move this somewhere better
export const parseTownsquareApp = (input?: string): 'home' | 'goals' | 'teams' => {
  switch (input) {
    case 'goals':
      return 'goals';
    case 'teams':
      return 'teams';
    case 'home':
    default:
      return 'home';
  }
};
